<template>
  <v-dialog
    :value="value"
    max-width="480"
    persistent
    data-testid="add-edit-owner-modal"
    @input="$emit('input', $event)"
  >
    <v-card class="add-edit-owner-modal">
      <v-card-title class="add-edit-owner-modal__header white--text">
        <span>{{ isEdit ? 'Edit Owner' : 'Add Owner' }}</span>
        <v-spacer />
        <v-btn
          icon
          dark
          data-testid="add-edit-owner-modal__close-btn"
          @click="close"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="add-edit-owner-modal__body">
        <div class="add-edit-owner-modal__field">
          <label class="add-edit-owner-modal__label">
            Full name <span class="add-edit-owner-modal__required">*</span>
          </label>
          <lb-string
            :value="form.name"
            label=""
            placeholder=""
            :error="fieldErrors.name"
            data-testid="add-edit-owner-modal__name"
            @input="updateField('name', $event)"
          />
        </div>

        <div class="add-edit-owner-modal__field">
          <label class="add-edit-owner-modal__label">
            Email <span class="add-edit-owner-modal__required">*</span>
          </label>
          <lb-string
            :value="form.email"
            label=""
            placeholder=""
            :error="fieldErrors.email"
            data-testid="add-edit-owner-modal__email"
            @input="updateField('email', $event)"
          />
        </div>

        <!-- <div
          v-if="!isEdit"
          class="add-edit-owner-modal__welcome d-flex align-center justify-end"
        >
          <span class="add-edit-owner-modal__welcome-label mr-3">Send welcome email</span>
          <v-switch
            v-model="sendWelcomeEmail"
            dense
            inset
            hide-details
            class="ma-0"
            data-testid="add-edit-owner-modal__welcome-toggle"
          />
        </div> -->
      </v-card-text>

      <v-card-actions class="add-edit-owner-modal__footer px-6 pb-6">
        <v-spacer />
        <v-btn
          outlined
          class="add-edit-owner-modal__cancel-btn text-capitalize secondaryBtn"
          data-testid="add-edit-owner-modal__cancel-btn"
          @click="close"
        >
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          class="white--text text-capitalize ml-3"
          :loading="loading"
          data-testid="add-edit-owner-modal__submit-btn"
          @click="submit"
        >
          {{ isEdit ? 'Save changes' : 'Add owner' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import './AddEditOwnerModal.scss';

const EMPTY_FORM = {
  name: '',
  email: '',
};

export default {
  name: 'AddEditOwnerModal',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    owner: {
      type: Object,
      default: null,
    },
    serverErrors: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: { ...EMPTY_FORM },
      validationErrors: {},
      sendWelcomeEmail: false,
    };
  },
  computed: {
    isEdit() {
      return Boolean(this.owner?._id);
    },
    fieldErrors() {
      return { ...this.serverErrors, ...this.validationErrors };
    },
  },
  watch: {
    value(open) {
      if (open) {
        this.resetForm();
      }
    },
    owner: {
      handler() {
        if (this.value) {
          this.resetForm();
        }
      },
      deep: true,
    },
  },
  methods: {
    resetForm() {
      this.validationErrors = {};
      this.sendWelcomeEmail = false;
      if (this.owner?._id) {
        this.form = {
          name: this.owner.name || '',
          email: this.owner.email || '',
        };
      } else {
        this.form = { ...EMPTY_FORM };
      }
    },
    updateField(field, value) {
      this.$set(this.form, field, value);
      if (this.validationErrors[field]) {
        this.$set(this.validationErrors, field, '');
      }
      if (this.serverErrors[field]) {
        this.$emit('clear-server-error', field);
      }
    },
    close() {
      this.$emit('input', false);
    },
    isValidEmail(email) {
      if (!email || typeof email !== 'string') return false;
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email.trim());
    },
    validate() {
      const errors = {};
      if (!this.form.name?.trim()) {
        errors.name = 'Full name is required';
      }
      if (!this.form.email?.trim()) {
        errors.email = 'Email is required';
      } else if (!this.isValidEmail(this.form.email.trim())) {
        errors.email = 'Please enter a valid email address';
      }
      this.validationErrors = errors;
      return Object.keys(errors).length === 0;
    },
    submit() {
      if (!this.validate()) return;

      const payload = {
        name: this.form.name.trim(),
        email: this.form.email.trim(),
      };

      if (this.isEdit) {
        payload.status = this.owner.status !== false;
        this.$emit('save', {
          mode: 'edit',
          id: this.owner._id,
          data: payload,
        });
        return;
      }

      this.$emit('save', {
        mode: 'add',
        data: {
          ...payload,
          status: true,
        },
        sendWelcomeEmail: this.sendWelcomeEmail,
      });
    },
  },
};
</script>
